var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{staticClass:"map--inner",style:({
      height: _vm.height,
      width: _vm.width,
    }),attrs:{"id":_vm.id}}),_vm._t("default",null,{"map":_vm.map})],2)}
var staticRenderFns = []

export { render, staticRenderFns }